<!-- <app-tab-header [tabs]="tabs"></app-tab-header> -->

<div class="container-fluid">

  <app-category-header [ruleName]="rule()!.name" [categories]="categoryHeader()"></app-category-header>

  @if(rulesService.isHighEndWatchesRule(rule())){

  <app-hew-category [rule]="rule()!"></app-hew-category>

  }

  @if(rule() && rule()?.newIn?.enabled){
  <app-new-in [newIn]="rule()?.newIn"></app-new-in>
  }

  @if(categoryBody()){
  <app-category-body [categories]="categoryBody()!"></app-category-body>
  }

  <!-- <app-categories></app-categories> -->

</div>
